import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

import { PlaceholderShape } from '../placeholder/PlaceholderShape';

const useFilterSelectPlaceholderStyles = makeStyles({
  root: {
    display: 'flex',
    gap: '15px',
  },
  selectItem: {
    width: '160px',
    height: '42px',
  },
});

export const FilterSelectPlaceholder = ({
  itemCount = 1,
  theme,
}: PropsWithTheme<{ itemCount: number }>) => {
  const classes = useFilterSelectPlaceholderStyles();

  return (
    <div className={classes.root}>
      {[...Array(itemCount)].map(() => (
        <PlaceholderShape theme={theme} className={classes.selectItem} level="2" rounded />
      ))}
    </div>
  );
};
